import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';
import './index.css';

// Restore redirected path from static 404 fallback if present
const redirect = sessionStorage.redirect;
delete sessionStorage.redirect;
if (redirect && redirect !== location.href) {
  history.replaceState(null, '', redirect);
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
